import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";
const initialState = {
    annualTurnover: [],
};
let URL = endpoints.annualTurnover;
const annualTurnoverSlice = createSlice({
    name: "annualTurnover",
    initialState,
    reducers: {
        annualTurnoverSuccess: (state = cloneDeep(initialState), action) => {
            const { row } = action.payload;
            return {
                ...state,
                annualTurnover: row,

            };
        },

        resetState: (state = cloneDeep(initialState), action) => {
            return {
                ...state,
                ...initialState,
            };
        },
    },
});

export const { annualTurnoverSuccess, resetState } = annualTurnoverSlice.actions;

export default annualTurnoverSlice.reducer;

export const getAnnualTurnover = () => async (dispatch) => {
    try {
        const response = apiGet({
            url: URL,
        }).then(({ data, success }) => {
            if (success) {
                const { content } = data.data;
                const row = content.map((annualTurnoverObject, index) => {
                    let annualTurnoverData = {
                        index: index + 1,
                        id: annualTurnoverObject.id === null ? "" : annualTurnoverObject.id,
                        name: annualTurnoverObject.name === null ? "" : annualTurnoverObject.name,
                        isActive: annualTurnoverObject.isActive === null ? "" : annualTurnoverObject.isActive,
                    };
                    return annualTurnoverData;
                });
                dispatch(annualTurnoverSuccess({ row }));
                return { response: row, success };
            }
            return { response: [], success };
        });
        return response;
    } catch (e) {
        return console.error(e.message);
    }
};
